export class ReviewsSlider { 
    init() { 
        const carousel = $('.owl-carousel--rewiews');

        if (carousel) {
            this.carousel(carousel);
        }
    }

    carousel(carousel) {
        carousel.owlCarousel({
            loop: true,
            margin: 24,
            nav: false,
            dots: false,
            autoplay: true,
            autoplayTimeout: 5000,
            center: true,
            responsive: {
                0: {
                    items: 1,
                },
                576: {
                    items: 2,
                },
                992: {
                    items: 4,
                },
                1024: {
                    items: 6,
                }
            }
        });
    }
}
